import Tracking from '@/pages/customer/freightiq/Tracking';

export default function LiveShipmentTracking() {
  return (
    <Tracking
      pageTitle="Live shipment tracking"
      pageSubtitle="DeMaxtore — canlı sevkiyat durumu (FreightIQ verisi)"
    />
  );
}
